import { IonLabel, IonSegment, IonSegmentButton } from '@ionic/react';
import { TAB_HEADERS_WEB } from '../../../utils/constants';
import React from 'react';
import { useHistory } from 'react-router';
import { ITabHeaderProps } from './tabs.schema';

const TabHeader: React.FC<ITabHeaderProps> = ({ setSegment, segments, activeSegment,}) => {
  const history = useHistory();
    const onTabChange = (e:any) => {
      setSegment({ name: e.detail.value, data: {}});
      e.detail.value === TAB_HEADERS_WEB.NEW_SEARCH && history.replace({...history,state:{...history.location.state,searchById: false,showResults: false}});
    }
    return (
        segments && segments.length > 0 ? (
            <IonSegment
                onIonChange={onTabChange}
                class="segment_control_tabs"
                value = {activeSegment}
                
            >
                {segments.map((name: any, index: number) => (
                  <IonSegmentButton
                    key={index}
                    value={name}
                   
                  >
                    <IonLabel className="segment_title_name">{name}</IonLabel>
                  </IonSegmentButton>
                ))}
            </IonSegment>
        ) : null
    )
};

export default TabHeader;